require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

!function (e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"));else if ("function" === typeof define && define.amd) define(["react"], t);else {
    var r = "object" === typeof exports ? t(require("react")) : t(e.react);

    for (var n in r) {
      ("object" === typeof exports ? exports : e)[n] = r[n];
    }
  }
}(window, function (e) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "/panz3r/react-keycloak/", r(r.s = 3);
  }([function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    "use strict";

    var n = Array.isArray,
        o = Object.keys,
        i = Object.prototype.hasOwnProperty,
        u = "undefined" !== typeof Element;

    e.exports = function (e, t) {
      try {
        return function e(t, r) {
          if (t === r) return !0;

          if (t && r && "object" == typeof t && "object" == typeof r) {
            var c,
                a,
                f,
                s = n(t),
                l = n(r);

            if (s && l) {
              if ((a = t.length) != r.length) return !1;

              for (c = a; 0 !== c--;) {
                if (!e(t[c], r[c])) return !1;
              }

              return !0;
            }

            if (s != l) return !1;
            var p = t instanceof Date,
                y = r instanceof Date;
            if (p != y) return !1;
            if (p && y) return t.getTime() == r.getTime();
            var d = t instanceof RegExp,
                m = r instanceof RegExp;
            if (d != m) return !1;
            if (d && m) return t.toString() == r.toString();
            var b = o(t);
            if ((a = b.length) !== o(r).length) return !1;

            for (c = a; 0 !== c--;) {
              if (!i.call(r, b[c])) return !1;
            }

            if (u && t instanceof Element && r instanceof Element) return t === r;

            for (c = a; 0 !== c--;) {
              if (("_owner" !== (f = b[c]) || !t.$$typeof) && !e(t[f], r[f])) return !1;
            }

            return !0;
          }

          return t !== t && r !== r;
        }(e, t);
      } catch (r) {
        if (r.message && r.message.match(/stack|recursion/i) || -2146828260 === r.number) return console.warn("Warning: react-fast-compare does not handle circular references.", r.name, r.message), !1;
        throw r;
      }
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        o = {
      childContextTypes: !0,
      contextType: !0,
      contextTypes: !0,
      defaultProps: !0,
      displayName: !0,
      getDefaultProps: !0,
      getDerivedStateFromError: !0,
      getDerivedStateFromProps: !0,
      mixins: !0,
      propTypes: !0,
      type: !0
    },
        i = {
      name: !0,
      length: !0,
      prototype: !0,
      caller: !0,
      callee: !0,
      arguments: !0,
      arity: !0
    },
        u = {
      $$typeof: !0,
      compare: !0,
      defaultProps: !0,
      displayName: !0,
      propTypes: !0,
      type: !0
    },
        c = {};

    function a(e) {
      return n.isMemo(e) ? u : c[e.$$typeof] || o;
    }

    c[n.ForwardRef] = {
      $$typeof: !0,
      render: !0,
      defaultProps: !0,
      displayName: !0,
      propTypes: !0
    };
    var f = Object.defineProperty,
        s = Object.getOwnPropertyNames,
        l = Object.getOwnPropertySymbols,
        p = Object.getOwnPropertyDescriptor,
        y = Object.getPrototypeOf,
        d = Object.prototype;

    e.exports = function e(t, r, n) {
      if ("string" !== typeof r) {
        if (d) {
          var o = y(r);
          o && o !== d && e(t, o, n);
        }

        var u = s(r);
        l && (u = u.concat(l(r)));

        for (var c = a(t), m = a(r), b = 0; b < u.length; ++b) {
          var h = u[b];

          if (!i[h] && (!n || !n[h]) && (!m || !m[h]) && (!c || !c[h])) {
            var v = p(r, h);

            try {
              f(t, h, v);
            } catch (k) {}
          }
        }

        return t;
      }

      return t;
    };
  }, function (e, t, r) {
    e.exports = r(6);
  }, function (e, t, r) {
    "use strict";

    e.exports = r(5);
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = "function" === typeof Symbol && Symbol["for"],
        o = n ? Symbol["for"]("react.element") : 60103,
        i = n ? Symbol["for"]("react.portal") : 60106,
        u = n ? Symbol["for"]("react.fragment") : 60107,
        c = n ? Symbol["for"]("react.strict_mode") : 60108,
        a = n ? Symbol["for"]("react.profiler") : 60114,
        f = n ? Symbol["for"]("react.provider") : 60109,
        s = n ? Symbol["for"]("react.context") : 60110,
        l = n ? Symbol["for"]("react.async_mode") : 60111,
        p = n ? Symbol["for"]("react.concurrent_mode") : 60111,
        y = n ? Symbol["for"]("react.forward_ref") : 60112,
        d = n ? Symbol["for"]("react.suspense") : 60113,
        m = n ? Symbol["for"]("react.suspense_list") : 60120,
        b = n ? Symbol["for"]("react.memo") : 60115,
        h = n ? Symbol["for"]("react.lazy") : 60116,
        v = n ? Symbol["for"]("react.fundamental") : 60117,
        k = n ? Symbol["for"]("react.responder") : 60118,
        g = n ? Symbol["for"]("react.scope") : 60119;

    function S(e) {
      if ("object" === typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case o:
            switch (e = e.type) {
              case l:
              case p:
              case u:
              case a:
              case c:
              case d:
                return e;

              default:
                switch (e = e && e.$$typeof) {
                  case s:
                  case y:
                  case f:
                    return e;

                  default:
                    return t;
                }

            }

          case h:
          case b:
          case i:
            return t;
        }
      }
    }

    function O(e) {
      return S(e) === p;
    }

    t.typeOf = S, t.AsyncMode = l, t.ConcurrentMode = p, t.ContextConsumer = s, t.ContextProvider = f, t.Element = o, t.ForwardRef = y, t.Fragment = u, t.Lazy = h, t.Memo = b, t.Portal = i, t.Profiler = a, t.StrictMode = c, t.Suspense = d, t.isValidElementType = function (e) {
      return "string" === typeof e || "function" === typeof e || e === u || e === p || e === a || e === c || e === d || e === m || "object" === typeof e && null !== e && (e.$$typeof === h || e.$$typeof === b || e.$$typeof === f || e.$$typeof === s || e.$$typeof === y || e.$$typeof === v || e.$$typeof === k || e.$$typeof === g);
    }, t.isAsyncMode = function (e) {
      return O(e) || S(e) === l;
    }, t.isConcurrentMode = O, t.isContextConsumer = function (e) {
      return S(e) === s;
    }, t.isContextProvider = function (e) {
      return S(e) === f;
    }, t.isElement = function (e) {
      return "object" === typeof e && null !== e && e.$$typeof === o;
    }, t.isForwardRef = function (e) {
      return S(e) === y;
    }, t.isFragment = function (e) {
      return S(e) === u;
    }, t.isLazy = function (e) {
      return S(e) === h;
    }, t.isMemo = function (e) {
      return S(e) === b;
    }, t.isPortal = function (e) {
      return S(e) === i;
    }, t.isProfiler = function (e) {
      return S(e) === a;
    }, t.isStrictMode = function (e) {
      return S(e) === c;
    }, t.isSuspense = function (e) {
      return S(e) === d;
    };
  }, function (e, t, r) {
    "use strict";

    function n(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function u(e, t, r) {
      return t && i(e.prototype, t), r && i(e, r), e;
    }

    function c(e) {
      return (c = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function a(e) {
      return (a = "function" === typeof Symbol && "symbol" === c(Symbol.iterator) ? function (e) {
        return c(e);
      } : function (e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : c(e);
      })(e);
    }

    function f(e, t) {
      return !t || "object" !== a(t) && "function" !== typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function s(e) {
      return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function l(e, t) {
      return (l = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function p(e, t) {
      if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && l(e, t);
    }

    r.r(t);
    var y = r(0),
        d = r.n(y),
        m = r(1),
        b = r.n(m),
        h = d.a.createContext(null);

    function v(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function k(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? v(r, !0).forEach(function (t) {
          n(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : v(r).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var g = {
      initialized: !1,
      isLoading: !0,
      token: void 0
    },
        S = function (e) {
      function t(e) {
        var r;
        if (o(this, t), (r = f(this, s(t).call(this, e))).state = k({}, g), r.onKeycloakError = function (e) {
          return function (t) {
            var n = r.props,
                o = n.onError,
                i = n.onEvent;
            o && o(t), i && i(e, t);
          };
        }, r.updateState = function (e) {
          return function () {
            var t = r.props,
                n = t.keycloak,
                o = t.onEvent,
                i = t.onToken,
                u = t.onTokens,
                c = t.isLoadingCheck,
                a = r.state,
                f = a.initialized,
                s = a.isLoading,
                l = a.token,
                p = n.idToken,
                y = n.refreshToken,
                d = n.token;
            o && o(e);
            var m = !!c && c(n);
            f && m === s && d === l || r.setState({
              initialized: !0,
              isLoading: m,
              token: d
            }), d !== l && (i && i(d), u && u({
              idToken: p,
              refreshToken: y,
              token: d
            }));
          };
        }, r.refreshKeycloakToken = function (e) {
          return function () {
            var t = r.props,
                n = t.keycloak,
                o = t.onEvent;
            o && o(e), n.updateToken();
          };
        }, !e.keycloak) throw new Error("KeycloakProvider requires 'keycloak' prop to be defined");
        return r;
      }

      return p(t, e), u(t, [{
        key: "componentDidMount",
        value: function value() {
          this.init();
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          var t = e.keycloak,
              r = e.initConfig;
          this.props.keycloak === t && b()(this.props.initConfig, r) || (t.onReady = null, t.onAuthSuccess = null, t.onAuthError = null, t.onAuthRefreshSuccess = null, t.onAuthRefreshError = null, t.onAuthLogout = null, t.onTokenExpired = null, this.setState(k({}, g)), this.init());
        }
      }, {
        key: "init",
        value: function value() {
          var e = this.props,
              t = e.initConfig,
              r = e.keycloak;
          r.onReady = this.updateState("onReady"), r.onAuthSuccess = this.updateState("onAuthSuccess"), r.onAuthError = this.onKeycloakError("onAuthError"), r.onAuthRefreshSuccess = this.updateState("onAuthRefreshSuccess"), r.onAuthRefreshError = this.onKeycloakError("onAuthRefreshError"), r.onAuthLogout = this.updateState("onAuthLogout"), r.onTokenExpired = this.refreshKeycloakToken("onTokenExpired"), r.init(k({}, t));
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.children,
              r = e.keycloak,
              n = e.LoadingComponent,
              o = this.state,
              i = o.initialized,
              u = o.isLoading;
          return !n || i && !u ? d.a.createElement(h.Provider, {
            value: {
              initialized: i,
              keycloak: r
            }
          }, t) : n;
        }
      }]), t;
    }(y.PureComponent);

    S.defaultProps = {
      initConfig: {
        onLoad: "check-sso"
      },
      isLoadingCheck: null,
      LoadingComponent: null,
      onError: null,
      onEvent: null,
      onToken: null
    };

    var O = S,
        j = r(2),
        P = r.n(j),
        w = function w(e) {
      return "WithKeycloak(".concat(e, ")");
    };

    var E = function E(e) {
      var t = h,
          r = w(e.displayName || e.name),
          n = function (r) {
        function n() {
          var t, r;
          o(this, n);

          for (var i = arguments.length, u = new Array(i), c = 0; c < i; c++) {
            u[c] = arguments[c];
          }

          return (r = f(this, (t = s(n)).call.apply(t, [this].concat(u)))).renderWrappedComponent = function (t) {
            var n = t.initialized,
                o = t.keycloak;
            return d.a.createElement(e, Object.assign({}, r.props, {
              keycloak: o,
              keycloakInitialized: n
            }));
          }, r;
        }

        return p(n, r), u(n, [{
          key: "render",
          value: function value() {
            return d.a.createElement(t.Consumer, null, this.renderWrappedComponent);
          }
        }]), n;
      }(y.Component);

      return n.WrappedComponent = e, n.displayName = r, P()(n, e);
    };

    var x = function x() {
      var e = Object(y.useContext)(h),
          t = e.initialized,
          r = e.keycloak;
      return Object.assign([r, t], {
        initialized: t,
        keycloak: r
      });
    };

    r.d(t, "KeycloakProvider", function () {
      return O;
    }), r.d(t, "withKeycloak", function () {
      return E;
    }), r.d(t, "useKeycloak", function () {
      return x;
    });
  }]);
});